import React, { Component } from 'react';
import Editor from '../../common/Quill';
import { getQuestionTypes, updateQuestion, getQuestion, getDT, saveDT } from '../../../services/formService';
import { toast, ToastContainer } from 'react-toastify';
import { toaster } from '../../../config';
import { QuestionTypes } from '../../../constants/QuestionTypes';
import { stripPTag, checkImgSize } from '../../common/commonFuncs';
import TypeText from './question_types/Basic_Type';
import TypeVideo from './question_types/Video_Type';
import TypeMultiChoice from './question_types/MultipleChoice_Type';
import TypeMatrix from './question_types/Matrix_Type';
import TypeScale from './question_types/Scale_Type';
import TypeNumeric from './question_types/Numeric_Type';
import TypePicklist from './question_types/Picklist_Type';
import TypeDropdown from './question_types/Dropdown_Type';
import { TextField } from '@material-ui/core';
import { logActivity } from '../../../services/utilService';
import TypeInstitution from "./question_types/Institution_Type";

class WQuestionAnswer extends Component {
	Question_types = [];

	state = {
		Project_ID: this.props.Project_ID,
		Widget_ID: this.props.Widget.Widget_ID,
		Question_ID: 0,
		Question_Type_ID: parseInt(this.props.Question_Type_ID),
		Question_Text: '',
		Description: '',
		Indicate_Response: false,
		Response_Required: false,
		Align_Horizontal: false,
		loading: true,
		canChangeType: false,
		Allow_Multiple_Selection: false,
		Custom_Render: null,
		WithinRow: false
	};

	constructor(props) {
		super(props);
		this.handleSave = this.handleSave.bind(this);
		this.handleWithinRowChange = this.handleWithinRowChange.bind(this);
		this.passDown = this.passDown.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
	}

	async componentDidMount() {
		this.setState({ loading: true });
		const { data: qTypes } = await getQuestionTypes();
		this.Question_types = qTypes.filter((type) => type.Question_Type_ID !== 8);

		// For rich text editor's link config
		const input = document.querySelector('input[data-link]');
		if (input) {
			input.dataset.link = '';
			input.placeholder = '';
		}

		const { data } = await getQuestion(this.props.Widget.Widget_ID);
		if (data.length > 0) {
			this.setState({ Question_ID: data[0].Question_ID });
			this.setState({ Question_Type_ID: data[0].Question_Type_ID });
			this.setState({ Question_Text: data[0].Question_Text });
			this.setState({ Description: data[0].Description });
			this.setState({ Response_Required: data[0].Response_Required });
			this.setState({ Indicate_Response: data[0].Indicate_Response });
			this.setState({ Align_Horizontal: data[0].Align_Horizontal });
			this.setState({ Allow_Multiple_Selection: data[0].Allow_Multiple_Selection })
			this.setState({ Custom_Render: data[0].Custom_Render })
		} else {
			this.setState({ canChangeType: true });
		}

		//Set Include in Row Widget data
		const { data: DTResponse } = await getDT(this.state.Widget_ID), dataDt = JSON.parse(DTResponse.DT)[0];
		this.setState({ WithinRow: dataDt ? dataDt['WithinRow'] : false, DT_ID: dataDt && dataDt['DT_ID'] ? dataDt['DT_ID'] : 0 })

		this.setState({ loading: false });
	}

	handleAllowMultipleSelection = (Allow_Multiple_Selection) => {
		this.setState({ Allow_Multiple_Selection });
	};

	handleWithinRowChange() {
		let dataDT = {
			DT_ID: (this.state.DT_ID) ? this.state.DT_ID : 0,
			Widget_ID: this.state.Widget_ID,
			DataSource_ID: null,
			ResultSource_ID: this.state.Question_ID,
			ResultSource_Content: this.state.Description,
			Action_ID: 0,
			Action_Form_ID: null,
			Display_Name: this.state.Question_Text,
			Parameters: [],
			Columns: [],
			WithinRow: (!this.state.WithinRow) ? 1 : 0
		}
		this.setState({ WithinRow: !this.state.WithinRow, dataDT });
	}

	handleChange = (input) => {
		let value = input.value;
		if (input.name.includes('ID')) {
			value = parseInt(value);
		} else {
			if (!checkImgSize(value)) {
				toaster('error', 'File size cannot exceed 1MB. Please resize the image.', { position: toast.POSITION.TOP_CENTER });
				value = this.state[input.name];
			}
		}
		this.setState({ [input.name]: value });
	};

	handleSave = async (Question_Answers = null) => {
		const Question_Text = stripPTag(this.state.Question_Text);
		this.setState({ Question_Text });
		if (this.state.WithinRow !== undefined && this.state.dataDT) {
			const { data: dataDT } = await saveDT(this.state.dataDT);
			//console.log('this.stateDT', this.state.dataDT, dataDT)
			if (dataDT.includes("Error")) {
				logActivity('/formBuilder', 'WIDGET_QA_WITHINROW_SAVE_FAILED');
				toaster('error', 'QA Include in Row not possible at the moment');
			} else {
				logActivity('/formBuilder', 'WIDGET_QA_WITHINROW_SAVE_SUCCESS');
			};
		}

		const { data } = await updateQuestion(Question_Text, Question_Answers, this.state);

		if (data.includes('Error')) {
			toaster('error', data);
			logActivity('/formBuilder', 'WIDGET_QUES_SAVE_FAILED');
			return 0;
		} else {
			const Question_ID = data.split(':').pop();
			this.setState({ Question_ID });
			this.setState({ canChangeType: false });
			toaster('success', 'Question saved.');
			logActivity('/formBuilder', 'WIDGET_QUES_SAVE_SUCCESS');
			return Question_ID;
		}
	};

	handleTypeChange = (type) => {
		this.setState({ Question_Type_ID: type });
	};

	handleRemove() {
		this.props.onRemove(this.props.Widget.Widget_ID);
	}

	handleSwitch = ({ target }) => {
		let name = target.name;
		this.setState({ [name]: !this.state[name] });
	};

	handleCanChangeType = () => {
		this.setState({ canChangeType: false });
	};

	passDown = () => {
		const { Question_Text, Description, Align_Horizontal, Response_Required, Indicate_Response } = this.state;

		return {
			Question_Text: stripPTag(Question_Text),
			Description: Description,
			Response_Required: Response_Required,
			Align_Horizontal: Align_Horizontal,
			Indicate_Response: Indicate_Response,
		};
	};

	render() {
		const { Project_ID, Widget_ID, Question_ID, Question_Type_ID, Question_Text, Response_Required, Indicate_Response, Align_Horizontal, Description, WithinRow, Custom_Render } = this.state;

		if (this.state.loading) return <div className='center'>Loading...</div>;

		return (
			<React.Fragment>
				{Question_Type_ID !== QuestionTypes.Video && Question_Type_ID !== QuestionTypes.Info && (
					<div className='d-flex justify-content-between'>
						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'indicateSwitch' + Widget_ID}
								type='checkbox'
								name='Indicate_Response'
								checked={Indicate_Response}
								value={Indicate_Response}
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'indicateSwitch' + Widget_ID}>
								Indicate Response
							</label>
						</div>

						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'horizontalSwitch' + Widget_ID}
								type='checkbox'
								checked={Align_Horizontal}
								value={Align_Horizontal}
								name='Align_Horizontal'
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'horizontalSwitch' + Widget_ID}>
								Inline Alignment
							</label>
						</div>

						<div className='custom-control custom-switch mt-n2'>
							<input
								className='custom-control-input'
								id={Question_ID + 'requiredSwitch' + Widget_ID}
								type='checkbox'
								checked={Response_Required}
								value={Response_Required}
								name='Response_Required'
								onChange={this.handleSwitch}
							/>
							<label className='custom-control-label' htmlFor={Question_ID + 'requiredSwitch' + Widget_ID}>
								Response Required
							</label>
						</div>
						{/* Add include in row Widget here */}
						<div className="custom-control custom-switch mt-n2">
							<input
								type="checkbox"
								className="custom-control-input"
								checked={WithinRow}
								value={WithinRow}
								onChange={this.handleWithinRowChange}
								name='Include_RowWidget'
								id={Question_ID + 'rowSwitch' + Widget_ID}
							/>
							<label htmlFor={Question_ID + 'rowSwitch' + Widget_ID} className="custom-control-label">
								Include in row widget
							</label>
						</div>
					</div>
				)}
				{this.state.canChangeType && (
					<div className='form-group'>
						<select className='custom-select' value={Question_Type_ID} name='Question_Type_ID' onChange={(e) => this.handleChange(e.target)}>
							<option>Select Question Type</option>
							{this.Question_types.map((type) => {
								return (
									<option key={type.Question_Type_ID} value={type.Question_Type_ID}>
										{type.Question_Type}
									</option>
								);
							})}
						</select>
					</div>
				)}

				<div className='form-group'>
					<label htmlFor='Question_Text'>Question Text</label>
					<Editor
						value={Question_Text}
						onChange={(value) =>
							this.handleChange({
								value: value,
								name: 'Question_Text',
							})
						}
					/>
				</div>
				<div className='form-group'>
					<TextField
						id={Question_ID + 'Description'}
						label='Question Description'
						multiline
						fullWidth
						maxRows={2}
						value={Description}
						name='Description'
						variant='outlined'
						onChange={(e) => this.handleChange(e.target)}
					/>
				</div>

				<div className="form-group">
					<label>Custom Rendering</label>
					<br />
					<textarea name='Custom_Render' id='Custom_Render' className='form-control' rows={4} value={Custom_Render} onChange={(e) => this.handleChange(e.target)} placeholder='' />
				</div>

				{/* Simple question types that requires only question text */}
				{(Question_Type_ID === QuestionTypes.Text || Question_Type_ID === QuestionTypes.Textarea || Question_Type_ID === QuestionTypes.Time || Question_Type_ID === QuestionTypes.Date || Question_Type_ID === QuestionTypes.Info) && (
					<TypeText Question_ID={Question_ID} Widget_ID={Widget_ID} onSave={this.handleSave} onRemove={this.handleRemove} />
				)}

				{/* Numeric & Numeric Tally */}
				{(Question_Type_ID === QuestionTypes.Numeric || Question_Type_ID === QuestionTypes.Numeric_Tally) && (
					<TypeNumeric
						onSave={this.handleSave}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						onTypeChange={this.handleTypeChange}
						isTally={Question_Type_ID === QuestionTypes.Numeric_Tally ? true : false}
					/>
				)}

				{/* Video */}
				{Question_Type_ID === QuestionTypes.Video && <TypeVideo onSave={this.handleSave} onRemove={this.handleRemove} Question_ID={this.state.Question_ID} />}

				{/* multiple choice */}
				{Question_Type_ID === QuestionTypes.Multiple_Choice && <TypeMultiChoice onSave={this.handleSave} onRemove={this.handleRemove} Question_ID={this.state.Question_ID} Widget_ID={this.state.Widget_ID} onMultipleSelection={this.handleAllowMultipleSelection} />}

				{/* picklist */}
				{Question_Type_ID === QuestionTypes.Picklist && <TypePicklist Project_ID={Project_ID} Custom_Render={Custom_Render} onSave={this.handleSave} onRemove={this.handleRemove} Question_ID={this.state.Question_ID}/>}

				{/* Matrix */}
				{Question_Type_ID === QuestionTypes.Matrix && (
					<TypeMatrix Widget_ID={this.props.Widget.Widget_ID} onSave={this.passDown} onRemove={this.handleRemove} onSuccessfulSave={this.handleCanChangeType} Question_ID={this.state.Question_ID} />
				)}

				{/* Scale Question */}
				{Question_Type_ID === QuestionTypes.Scale && <TypeScale onSave={this.handleSave} onRemove={this.handleRemove} Question_ID={this.state.Question_ID} />}

				{/* Dropdown */}
				{Question_Type_ID === QuestionTypes.Dropdown && (
					<TypeDropdown
						onSave={this.handleSave}
						// onSave={this.passDown}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						Widget_ID={this.state.Widget_ID}
						onMultipleSelection={this.handleAllowMultipleSelection}
						allowMultipleSelection={this.state.Allow_Multiple_Selection}
					/>
				)}

				{/* Checkbox */}
				{Question_Type_ID === QuestionTypes.Checkbox && <TypeText onSave={this.handleSave} onRemove={this.handleRemove} Question_ID={this.state.Question_ID} Question_Text={this.state.Question_Text} Question_Type_ID={Question_Type_ID} />}

				{/* Institution */}
				{Question_Type_ID === QuestionTypes.Institution && (
					<TypeInstitution
						onSave={this.handleSave}
						// onSave={this.passDown}
						onRemove={this.handleRemove}
						Question_ID={this.state.Question_ID}
						Widget_ID={this.state.Widget_ID}
						onMultipleSelection={this.handleAllowMultipleSelection}
						allowMultipleSelection={this.state.Allow_Multiple_Selection}
					/>
				)}

				{Number.isNaN(Question_Type_ID) && (
					<div className='float-right mt-2'>
						<button className='btn btn-outline-danger' onClick={this.handleRemove}>
							Delete
						</button>
					</div>
				)}
				<ToastContainer />
			</React.Fragment>
		);
	}
}

export default WQuestionAnswer;
